import { jp2yale, PhoneticType, yale2jp } from '../constants';
import replaceAll from './replaceAll';

/** Convert a complete transcription, including a syllable at end of input. */
const convertRomanization = (text: string, target: PhoneticType, source: PhoneticType): string => {
    if (source === target) return text;
    if (source === PhoneticType.Invalid || target === PhoneticType.Invalid) {
        throw new Error(`Unsupported romanisation conversion: ${source} to ${target}`);
    }

    const rules = target === PhoneticType.Yale ? jp2yale : yale2jp;
    // Conversion rules use a following separator to identify final syllables.
    let converted = `${target === PhoneticType.Jyutping ? text.normalize('NFD') : text} `;
    rules.forEach(({ from, to }) => {
        converted = replaceAll(converted, from, to);
    });
    converted = converted.slice(0, -1);
    return target === PhoneticType.Yale ? converted.normalize('NFC') : converted;
};

export default convertRomanization;
